import init from './core/index';
import version from './version';

export { version, init };

export default { version: version, init: init };
